import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Mascot from './Mascot';

// Phase descriptions shown one-at-a-time while Claude works.
// Rough timing: each phase advances after `phaseMs`, with the last phase
// lingering until the response actually arrives.
const PHASES = [
  { label: 'Finding the textbook section…', icon: '📖' },
  { label: 'Solving it the book\'s way…', icon: '✏️' },
  { label: 'Writing your walkthrough…', icon: '✨' },
  { label: 'Almost there…', icon: '⏳' },
];

const phaseMs = 6000; // advance every ~6 seconds (matches pipeline stage duration)

export default function LoadingProgress() {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setPhase((p) => Math.min(p + 1, PHASES.length - 1));
    }, phaseMs);
    return () => clearInterval(timer);
  }, []);

  const progress = ((phase + 1) / PHASES.length) * 100;
  const current = PHASES[phase];

  return (
    <div className="max-w-sm mx-auto px-5 pt-16 text-center space-y-6">
      <Mascot mood="thinking" size={120} />

      <div className="space-y-3">
        <div className="flex items-center justify-center gap-2">
          <motion.span
            key={current.icon}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="text-2xl"
          >
            {current.icon}
          </motion.span>
          <motion.p
            key={current.label}
            initial={{ y: 4, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="font-display font-bold text-lg"
          >
            {current.label}
          </motion.p>
        </div>

        {/* Progress bar */}
        <div className="h-2 bg-ink/10 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-gradient-to-r from-coral to-violet rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          />
        </div>

        {/* Phase dots */}
        <div className="flex items-center justify-center gap-2">
          {PHASES.map((_, i) => (
            <span
              key={i}
              className={`w-2 h-2 rounded-full transition-colors ${
                i < phase ? 'bg-sky' : i === phase ? 'bg-coral' : 'bg-ink/15'
              }`}
            />
          ))}
        </div>
      </div>

      <p className="text-xs text-ink/50">
        Grounding the answer in Big Ideas Math Course 1 · California edition
      </p>
    </div>
  );
}
